import { render } from "./SearchScreen.vue?vue&type=template&id=b551dfe2"
import script from "./SearchScreen.vue?vue&type=script&lang=js"
export * from "./SearchScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__